module.exports = __webpack_public_path__ + "static/media/mx.5dd7558e.png";